import Loader from "@/components/Loader/Loader";
import routes from "@/routes/routes";
import { memo, Suspense, useEffect, useState } from "react";
import { Link, Outlet, useLocation, useParams } from "react-router-dom";
import styles from "./PreLogin.module.scss";
import DisRoutes from "@/routes/DisRoutes";
import { useRole } from "@/pages/Role/Role";

const PreLogin = () => {
  const { role: contextRole } = useRole();
  const { role: paramRole } = useParams<{ role: string }>();
  const role = contextRole || paramRole;
  const location = useLocation();
  const isRegisterPage = location.pathname.endsWith("registration");
  const isLoginPage = location.pathname.endsWith("/login");
  // const isRegisterPage = pathname.includes("/registration");
  const isForgotPage = location.pathname.endsWith("/forgot-password");
  const isOtpPage = location.pathname.endsWith("/otp-verification");
  const isOtpVerificaion = location.pathname.endsWith("/login-otp-verification");
  const isLandingPage = location.pathname === "/";



  const pathname = location.pathname;



  const showHeading = isLoginPage || isRegisterPage || isForgotPage || isOtpPage || isOtpVerificaion;




  return (
    <div className={styles.mainContainer}>
      {showHeading && (
      <div className={styles.main_img}>
        <div className={styles.main_img_content}>
            <div className={styles.headingDiv}>
              <h2 className={styles.heading}>
                {/* {isRegisterPage ? (
                <>
                  Distributor <br /> Merchant Registration
                </>
              ) : (
                <>
                  Distributor <br /> Merchant Login
                </>
              )} */}
                {isRegisterPage ? (
                  <>
                    {role === "retailer" ? "Retailer" : "Distributor"} <br /> Merchant Registration
                  </>
                ) : (
                  <>
                    {role === "retailer" ? "Retailer" : "Distributor"} <br /> Merchant Login
                  </>
                )}

              </h2>

              <p className={styles.subHeading}>
                {/* {isRegisterPage
                ? "Fill in your details to register as a distributor or merchant and get started."
                : "Log in to your distributor dashboard to manage inventory & unlock exclusive deals."} */}
                {isRegisterPage
                  ? `Fill in your details to register as a ${role === "retailer" ? "retailer" : "distributor"} or merchant and get started.`
                  : `Log in to your ${role === "retailer" ? "retailer" : "distributor"} dashboard to manage inventory & unlock exclusive deals.`}
              </p>
              <div className={styles.arrowBox}>
                →
              </div>
            </div>
        </div>
      </div>
      )}
      <div className={`${styles.yellowStrip} ${showHeading ? styles.alignStrip : ""}`}>

        <div className={styles.childrenContainer}>
          <div className={`${styles.loginBox} ${isRegisterPage ? styles.largeBox : styles.smallBox}`}>
            <Suspense fallback={<Loader />}>
              <Outlet />
            </Suspense>
            {location.pathname === "/login" && (
              <span >
                <p className={styles.signupContainer}>
                  Don’t have an account? &nbsp;
                  <Link
                    to={DisRoutes?.publicRoutes?.DIS_REGISTER?.path ?? "/"}
                    className="font-bold  hover:underline"
                  >
                    Sign up
                  </Link>
                </p>
              </span>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default memo(PreLogin);
